import i18next from 'i18next'
import { FormErrors } from 'redux-form'
import { isEmpty } from 'lodash'

// types
import { IForm } from '../../../types/interfaces'

export default (values: IForm) => {
	const errors: FormErrors<IForm> = {}
	if (values.autoDialingDelay && Number(values.autoDialingDelay) > 300) {
		errors.autoDialingDelay = i18next.t('loc:Max value is {{ max }}', { max: 300 }) as string
	}
	if (!values?.name) {
		errors.name = i18next.t('loc:Toto pole je povinné') as string
	}

	if (!values?.queue) {
		errors.queue = i18next.t('loc:Toto pole je povinné') as string
	}

	if (!values?.database) {
		errors.database = i18next.t('loc:Toto pole je povinné') as string
	}

	if (!values?.type || isEmpty(values?.type)) {
		errors.type = i18next.t('loc:Toto pole je povinné') as string
	}

	return errors
}
